import { ChronicDiseaseCannotBeRemovedWithoutReasonFault } from '@dreryk/egabinet-visit-frontend-api';

import { customEventFactory } from '@dreryk/react-common';

import { ChronicDiseaseRemovalParameters, ChronicDiseaseRemovalState } from './RemovalChronicDiseaseModal.types';

const SHOW_REMOVAL_CHRONIC_DISEASE_MODAL_EVENT = 'ShowRemovalChronicDiseaseModalEvent';

const [
   dispatchEvent,
   registerShowRemovalChronicDiseaseModalEventListener,
] = customEventFactory<ChronicDiseaseRemovalState>(SHOW_REMOVAL_CHRONIC_DISEASE_MODAL_EVENT);

export type OnShowRemovalChronicDiseaseModalEvent = (
   fault: ChronicDiseaseCannotBeRemovedWithoutReasonFault,
   onSubmit: (parameters: ChronicDiseaseRemovalParameters) => void,
   onCancel: VoidFunction
) => boolean;

export const dispatchShowRemovalChronicDiseaseModalEvent: OnShowRemovalChronicDiseaseModalEvent = (
   fault,
   onSubmit,
   onCancel
) => dispatchEvent({ fault: fault, onSubmit: onSubmit, onCancel: onCancel });

export { registerShowRemovalChronicDiseaseModalEventListener };
